import ApiService from './ApiService';
// import ToastService from '../services/ToastService';

class AuthService {

  constructor(router) {
    this.router = router; // Store the router instance
  }

  async login(email, password, isCustomer = false) {
    try {
      const url = isCustomer ? '/customer/login' : '/login';
      const response = await ApiService.request({
        method: 'POST',
        url: url,
        data: { email, password },
      });

      return response.data;
    } catch (error) {
      // Handle the error, you might want to show a toast notification or similar
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('user');
    window.location.href=process.env.REACT_APP_BASE_PATH+'/login';
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

const authServiceInstance = new AuthService(/* pass your router instance here */);
export default authServiceInstance;
